import React, {useState} from "react";
import CollegePageContainer from "../../Container/CollegePageContainer";
import JobListingFull from "../../../Components/JobListingFull/JobListingFull";
import ConfirmButton from "../../../Components/Buttons/ConfirmButton";
import CancelButton from "../../../Components/Buttons/CancelButton";
import ConfirmDelete from "./ConfirmDelete";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { API } from "../../../API";
import { notify } from "react-notify-toast";
import Modal from "../../../Components/Modal/Modal";

function JobListing(props) {
  const { job, inst, campus } = props;
  const isOwnListing = job.inst_id === props.institution._id;
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const handleDelete = (id) => {
    API.deleteListing(id)
      .then((res) => {
        notify.show("Listing deleted successfully");
        props.history.push("/MyListings");
      })
      .catch((err) => {
        console.log(err.response);
        notify.show("Error deleting listing");
      });
  };

  let tabs = [
    {
      text: "Job Listing",
      pathname: `/JobListing/${job._id}`,
      active: true,
    },
  ];

  if (isOwnListing && (props.user.role === "customer" || props.user.role === "personnel")) {
    tabs.push({
      text: "View Applicants",
      pathname: `/JobListing/Applicants/${job._id}`,
    });
  }
  
  if (job.status === "published" || job.inst_id === props.institution._id) {
    return (
      <CollegePageContainer header="Job Board" tabs={tabs} user={props.user}>
        <JobListingFull
          job={job}
          inst={inst}
          campus={campus}
          showSharePopup={
            props.location.state && props.location.state.showSharePopup
          }
          isCustomer={props.user.role === "customer"}
        />
        {isOwnListing && (
          <div className="mt-3 row justify-content-center">
            {/* <div className="col-lg-3 mt-2">
              <CancelButton onClick={() => props.history.push("/MyListings")}>
                Back to My Listings
              </CancelButton>
            </div> */}
            <div className="col-lg-3 mt-2">
              <CancelButton onClick={(e) => setShowDeletePopup(true)}>
                Delete Listing
              </CancelButton>
              {/* <ConfirmDelete
                state={this.state}
                onCancel={this.onCancel}
                onDelete={this.onDelete}
              /> */}
              {/*              <CancelButton onClick={(e) => handleDelete(job._id)}>
                Delete Listing
              </CancelButton>*/}
            </div>
            <div className="col-lg-3 mt-2">
              <ConfirmButton
                onClick={() =>
                  props.history.push(`/JobListing/Edit/${job._id}`)
                }
              >
                Edit Listing
              </ConfirmButton>
            </div>
          </div>
        )}
        <Modal
            show={showDeletePopup}
            onClose={() => setShowDeletePopup(false)}
            header="Do you wish to delete?"
            className="delete-listing-modal"
        >
          <div className="row m-0">
            <div className="col-md-6">
              <CancelButton
                  type="button"
                  onClick={() => setShowDeletePopup(false)}
              >
                Cancel
              </CancelButton>
            </div>
            <div className="col-md-6 padding-for-mobile">
              <ConfirmButton
                  type="button"
                  onClick={(e) => handleDelete(job._id)}
                  id={'q._id'}
              >
                Yes and Proceed
              </ConfirmButton>
            </div>
          </div>
        </Modal>
      </CollegePageContainer>
    );
  } else {
    // will need to define how this is rendered for people w/o viewing permissions
    return "test";
  }
}

function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
  };
}

export default connect(mapStateToProps)(withRouter(JobListing));
